// extracted by mini-css-extract-plugin
module.exports = {"preloader":"preparingCheckout_preloader__tkmE0"};